import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { Grid, FormControl, FormLabel, FormGroup, FormControlLabel, Checkbox, } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { lowerFirst } from 'lodash-es';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        height: 140,
        width: 100,
    },
    control: {
        padding: theme.spacing(2),
    },
}));

const Cancelar = ({ register, errors, setValue, watch, defaultItem, ctlg, }) => {
    const classes = useStyles();
    const requerido = { required: { value: defaultItem.accion =='cnclr'?true:false, message: 'Campo requerido' } }

    return (
        <Grid container className={classes.root} spacing={2} >
            <Grid item md={12} xs={12}>
                <TextField size="small"
                    variant="outlined" fullWidth
                    label="Observaciones" name="observacion"
                    error={errors.observacion != undefined} helperText={errors.observacion} 
                    defaultValue={defaultItem.observacion}
                    inputRef={register(requerido)}
                />
            </Grid>
        </Grid>
    );
};

export default Cancelar;